module.exports = __webpack_public_path__ + "static/11-3ab6e895be5fa7a8fb4e87aec07496ac.jpg";